<div class="slideshow" [class.cover]="cover" [class.interactive]="interactive" [class.paused]="paused" [style.height]="explicitHeight" [style.padding-bottom]="paddingBottom" [style.--slideshow-fade]="fadeCss" (click)="togglePaused()">
  <ng-content></ng-content>
  <span class="overlay" *ngIf="backgroundImageOverlayCss" [style.background-image]="backgroundImageOverlayCss"></span>
  <!-- aria-hidden: the pause button below already announces the state through
       aria-pressed and its label. -->
  <svg class="pauseIndicator" *ngIf="interactive" [class.visible]="paused" viewBox="0 0 100 100" aria-hidden="true" focusable="false">
    <circle cx="50" cy="50" r="47" fill="none" stroke="currentColor" stroke-width="5"></circle>
    <rect x="35" y="30" width="11" height="40" rx="2.5" fill="currentColor"></rect>
    <rect x="54" y="30" width="11" height="40" rx="2.5" fill="currentColor"></rect>
  </svg>
  <!-- Real buttons rather than handlers on the container: they are keyboard
       reachable and correctly announced on their own, and nesting them inside a
       role="button" container would not be.  The container keeps its click, so
       a pointer can still pause anywhere on the image. -->
  <div class="controls" *ngIf="navigable">
    <button type="button" class="nav previous" (click)="previous($event)" aria-label="Previous slide">
      <svg viewBox="0 0 100 100" aria-hidden="true" focusable="false">
        <circle cx="50" cy="50" r="47" fill="none" stroke="currentColor" stroke-width="5"></circle>
        <polyline points="58,28 36,50 58,72" fill="none" stroke="currentColor" stroke-width="8" stroke-linecap="round" stroke-linejoin="round"></polyline>
      </svg>
    </button>
    <button type="button" class="nav next" (click)="next($event)" aria-label="Next slide">
      <svg viewBox="0 0 100 100" aria-hidden="true" focusable="false">
        <circle cx="50" cy="50" r="47" fill="none" stroke="currentColor" stroke-width="5"></circle>
        <polyline points="58,28 36,50 58,72" fill="none" stroke="currentColor" stroke-width="8" stroke-linecap="round" stroke-linejoin="round"></polyline>
      </svg>
    </button>
    <!-- The visible text is phrased for the pointer that revealed it; the label
         is what assistive tech reads. -->
    <button type="button" class="pauseHint" *ngIf="interactive" (click)="togglePaused($event)" [attr.aria-pressed]="paused" [attr.aria-label]="label">{{ hint }}</button>
  </div>
</div>
